import { useState, useEffect } from 'react';
import { getPersonalizzazioni } from '../services/personalizzazioniApi';
import i18n from '../i18n';

const CACHE_KEY = 'psc_brand';

export const loadBrand = () => {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY) || '{}'); } catch { return {}; }
};

const useBrand = () => {
    const [brand, setBrand] = useState(loadBrand);

    useEffect(() => {
        if (!localStorage.getItem('token')) return;
        getPersonalizzazioni().then(data => {
            setBrand(data);
            localStorage.setItem(CACHE_KEY, JSON.stringify(data));
            // Sincronizza la lingua con i18next appena arrivano i dati dal backend
            if (data.lingua_interfaccia && data.lingua_interfaccia !== i18n.language) {
                i18n.changeLanguage(data.lingua_interfaccia);
            }
        }).catch(() => {});
    }, []);

    return brand;
};

export default useBrand;
